import { render, staticRenderFns } from "./CPU.vue?vue&type=template&id=a6a567ec&"
import script from "./CPU.vue?vue&type=script&lang=js&"
export * from "./CPU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6a567ec')) {
      api.createRecord('a6a567ec', component.options)
    } else {
      api.reload('a6a567ec', component.options)
    }
    module.hot.accept("./CPU.vue?vue&type=template&id=a6a567ec&", function () {
      api.rerender('a6a567ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/CPU.vue"
export default component.exports